import Vue from "vue";

import shortcutComponent from "@/components/parent/shortcut/shortcut.vue";
import { Component, Prop } from "@/decorators";
import UsuarioService from "@/services/usuarioService";

import "../crud/crud.scss";
import ShortcutComponent from "../shortcut/shortcut";

@Component({
    components: {
        shortcutComponent,
    },
})
export default class SolicitarSenhaComponent extends Vue {
    @Prop(String) title: string;
    @Prop({ type: String, default: "senhaAdmin" }) tipoValidacao!: string;

    private usuarioService = new UsuarioService();

    private shortcutComponent: ShortcutComponent = null;

    private senhaUsuario = "";
    isOpened = false;

    public show() {
        this.senhaUsuario = "";
        this.isOpened = true;
        this.shortcutComponent.title = this.getTitulo();
        this.shortcutComponent.show();
    }

    private getTitulo(): string {
        switch (this.tipoValidacao) {
            case "alteracaoValidadeProduto":
            case "edicaoFormulaPadrao":
                return "Solicitação de senha";
            default:
                return "Solicitação de senha do Administrador Franqueado";
        }
    }

    private async save() {
        const isValid = await this.$validator.validateAll();
        if (isValid) {
            const sucesso = await this.getValidacao(this.senhaUsuario).withLoading().resolveWithJSON<boolean>();

            this.shortcutComponent.hidewithoudOutputEvent();
            this.isOpened = false;

            this.$emit("onResult", sucesso);
        }
    }

    private getValidacao(senha: string): Promise<Response> {
        switch (this.tipoValidacao) {
            case "alteracaoValidadeProduto":
                return this.usuarioService.validarSenhaUsuarioAdminValidadeProduto(senha);
            case "edicaoFormulaPadrao":
                return this.usuarioService.validarSenhaUsuarioEdicaoFormulaPadrao(senha);
            default:
                return this.usuarioService.validarSenhaUsuarioAdmin(senha);
        }
    }

    private async hide() {
        this.isOpened = false;
        this.$emit("onCancel");
    }

    private async mounted() {
        this.shortcutComponent = this.$refs.shortcutComponent as ShortcutComponent;
    }
}
